export const getPdfDialogData = (state) => state.PdfDialog.Data;
